import { render } from "./settingsProfileStat.vue?vue&type=template&id=2d1cda1e&scoped=true"
import script from "./settingsProfileStat.vue?vue&type=script&lang=js"
export * from "./settingsProfileStat.vue?vue&type=script&lang=js"

import "./settingsProfileStat.vue?vue&type=style&index=0&id=2d1cda1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1cda1e"]])

export default __exports__